import React from 'react'
import Avatar from 'src/Components/Avatar'
import { If, Text } from 'src/Components'
import Dropdown from 'src/Components/Dropdown'
import NMLS from 'src/Components/NMLS'

import styles from './AgentDropdown.module.scss'

const AgentDropdown = ({
  className,
  city,
  corporateName,
  logo,
  nmls,
  officeName,
  open,
  setOpen,
  showAddress,
  state,
  street,
  zip
}) => (
  <Dropdown
    className={className}
    open={open}
    setOpen={setOpen}
    buttonProps={{
      children: <Avatar className={styles.avatar} src={logo} />
    }}
    headline={<Text>{corporateName}</Text>}
  >
    <div className={styles.dropdown}>
      <If condition={officeName}>
        <Text>{officeName}</Text>
      </If>
      <If condition={showAddress}>
        <Text>{street}</Text>
        <Text>
          {city}, {state} {zip}
        </Text>
      </If>
      <NMLS value={nmls} />
    </div>
  </Dropdown>
)

export default AgentDropdown
